import * as geometryEngine from 'esri/geometry/geometryEngine'
import Point = require('esri/geometry/Point');
import Graphic = require("esri/Graphic");
import PopupTemplate = require("esri/PopupTemplate");
import Query = require("esri/rest/support/Query");
import MapView = require("esri/views/MapView");
import { Polyline } from 'esri/geometry';
import * as baseGroup from "../../data/Layers/baseGroup";
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";
import { setClickPoint } from '../App/setupView';

// GetRouteStationingData

export default class GetRouteStationingData extends ToolButton {
  private eventHandler: IHandle;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    document.body.style.cursor = "default";
  }

  loadPopupTemplate(feature: Graphic) {
    try {
      const popupContent = [
        {
          type: "fields",
          fieldInfos: [
            {
              fieldName: "NAME",
              label: "Street Name"
            },
            {
              fieldName: "INVENTORY",
              label: "Key Route"
            },
            {
              fieldName: "expression/sta",
              label: "Station"
            },
            {
              fieldName: "expression/lat",
              label: "Latitude"
            },
            {
              fieldName: "expression/lon",
              label: "Longitude"
            },
          ]
        },
      ];
      const iroadsPopupTemplate = new PopupTemplate({
        title: "Route Stationing Data",
        outFields: ["*"],
        expressionInfos: [
          {
            name: "sta",
            title: "Station",
            expression: "Text(Round($feature.STA,2), '#.00')"
          },
          {
            name: "lat",
            title: "Latitude",
            expression: "Text($feature.LAT, '#.0000000')"
          },
          {
            name: "lon",
            title: "Longitude",
            expression: "Text($feature.LON, '#.0000000')"
          },
        ],
        content: popupContent
      });

      feature.popupTemplate = iroadsPopupTemplate;

      this.view.popup.set({
        features: [feature], // featureSet.features,
        // popupTemplate: iroadsPopupTemplate,
        title: "Route Stationing"
      });

      this.view.popup.visible = true;
      document.body.style.cursor = "default";
      this.toolbar.setPanAsActiveTool();

    } catch (error) {
      console.error("Error: in loadPopupTemplate " + error.message);
    }
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("GetRouteStationingData start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar && this.view) {
        this.toolbar.setActiveTool(this as ToolButton);
        this.view.focus();
        document.body.style.cursor = "crosshair";
        this.eventHandler = this.view.on("click", mouseEvent => {
          mouseEvent.stopPropagation();
          document.body.style.cursor = "wait";

          this.view.popup.visible = false;
          this.view.popup.clear();

          const query = new Query({
            // objectIds: [189280],
            geometry: mouseEvent.mapPoint,
            spatialRelationship: "intersects",
            distance: 50,
            units: "meters",
            outFields: ["*"],
            returnGeometry: true
          });

          // console.log("start raods query");
          baseGroup.idotRoadsLayer
            .queryFeatures(query)
            .then(featureSet => {
              if (featureSet.features.length > 0) {
                let closestDist = 999999;
                let closestIndex = 0;
                featureSet.features.forEach((value, index) => {
                  const dist = geometryEngine.distance(mouseEvent.mapPoint, value.geometry, "meters");
                  if (dist < closestDist) {
                    closestDist = dist;
                    closestIndex = index;
                  }
                });

                const feature = featureSet.features[closestIndex].clone();
                const begSta = feature.attributes.BEG_STA;
                const endSta = feature.attributes.END_STA;

                const line = feature.geometry as Polyline;
                const nearestPointResult = geometryEngine.nearestCoordinate(line, mouseEvent.mapPoint);

                const begPt = new Point({
                  x: line.paths[0][nearestPointResult.vertexIndex][0],
                  y: line.paths[0][nearestPointResult.vertexIndex][1],
                  spatialReference: line.spatialReference
                });
                const endPt = new Point({
                  x: line.paths[0][nearestPointResult.vertexIndex + 1][0],
                  y: line.paths[0][nearestPointResult.vertexIndex + 1][1],
                  spatialReference: line.spatialReference
                });

                let dist0 = geometryEngine.distance(begPt, nearestPointResult.coordinate, "meters");
                let dist1 = geometryEngine.distance(endPt, nearestPointResult.coordinate, "meters");

                for (let i = 0; i < line.paths[0].length - 1; i++) {
                  const segBeg = new Point({
                    x: line.paths[0][i][0],
                    y: line.paths[0][i][1],
                    spatialReference: line.spatialReference
                  });
                  const segEnd = new Point({
                    x: line.paths[0][i + 1][0],
                    y: line.paths[0][i + 1][1],
                    spatialReference: line.spatialReference
                  });
                  const segLen = geometryEngine.distance(segBeg, segEnd, "meters");

                  if (i < nearestPointResult.vertexIndex) {
                    dist0 += segLen;
                  } else if (i > nearestPointResult.vertexIndex) {
                    dist1 += segLen;
                  }
                }

                const pctAlong = dist0 / (dist0 + dist1);
                const sta = begSta + pctAlong * (endSta - begSta);


                feature.attributes.NAME = (feature.attributes.labelr ? feature.attributes.labelr + " " : "") + feature.attributes.ROAD_NAME;
                feature.attributes.LAT = nearestPointResult.coordinate.latitude;
                feature.attributes.LON = nearestPointResult.coordinate.longitude;
                feature.attributes.STA = sta;
                feature.geometry = nearestPointResult.coordinate;

                setClickPoint(mouseEvent.mapPoint);

                this.loadPopupTemplate(feature);

              } else {
                console.log("no roads retruned");
                alert("No road found. Try again.");
                document.body.style.cursor = "crosshair";
              }
            })
            .catch(reason => {
              document.body.style.cursor = "crosshair";
              console.log("Error in getRouteStationingData ", reason);
            });
        });
      }
    } catch (error) {
      console.error("Error: in GetRouteStationingData " + +error.message);
      document.body.style.cursor = "crosshair";
    }
  }
}
